"use client";

import { useEffect } from "react";
import { requestNotificationPermission } from "@/lib/notification";
import { subscribeUser } from "@/lib/pushHelper";
import { registerServiceWorker } from "@/lib/registerSW";

export default function PushInitializer() {
  useEffect(() => {
    let mounted = true;

    async function initPush() {
      if (!mounted) return;

      const granted = await requestNotificationPermission();
      if (!granted) return;

      await registerServiceWorker();
      await subscribeUser();
    }

    initPush();

    return () => {
      mounted = false;
    };
  }, []);

  return null;
}
